let config;


config = require( `./modules/${ process.env.APP_ENV }.js` ).default;

export default config;



// WEBPACK FOOTER //
// ./src/config/index.js